module.exports = __webpack_public_path__ + "media/images/flags/16/Peru-59c38a108bf24b77ffc15741eecd6757.png";